import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';

export const getAllAgentRooms = async (): Promise<AxiosResponse> => AxiosInstance.get('rooms.get');
